export default {
  path: '/operating_systems',
  name: 'operating_systems',
  component: () => import('../components/operatingsystem/Layout'),
  redirect: { name: 'OperatingSystemList' },
  meta: {
    breadcrumb: 'profile.operatingsystem.operatingsystems',
  },
  children: [
    {
      name: 'OperatingSystemList',
      path: '',
      component: () => import('../views/operatingsystem/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'OperatingSystemCreate',
      path: 'new',
      component: () => import('../views/operatingsystem/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'OperatingSystemUpdate',
      path: ':id/edit',
      component: () => import('../views/operatingsystem/Update'),
      meta: {
        breadcrumb: 'profile.operatingsystem.operatingsystem',
      },
    },
    {
      name: 'OperatingSystemShow',
      path: ':id',
      component: () => import('../views/operatingsystem/Show'),
      meta: {
        breadcrumb: 'profile.operatingsystem.operatingsystem',
      },
    },
    {
      name: 'OperatingSystem',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileOperatingSystemCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
